import { editorStyles } from '../constants/styles';

export const injectStyles = () => {
  const styleId = 'lexical-editor-styles';
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;

  const cssText = Object.entries(editorStyles)
    .map(([selector, styles]) => {
      const cssProps = Object.entries(styles)
        .map(([prop, value]) => `${prop.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value}`)
        .join(' ');
      return `${selector} { ${cssProps} }`;
    })
    .join('\n');

  style.textContent = cssText;
  document.head.appendChild(style);
};
